import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-16">
        <div className="max-w-lg mx-auto text-center space-y-6">
          <XCircle className="w-20 h-20 mx-auto text-gray-400" />
          <h1 className="text-3xl font-light">Order Cancelled</h1>
          <p className="text-gray-600">
            Your order has been cancelled. No payment was processed.
          </p>
          <p className="text-sm text-gray-500">
            Your cart items are still saved if you'd like to complete your purchase later.
          </p>

          <div className="space-x-4 pt-4">
            <Link
              to="/checkout"
              className="inline-block bg-black text-white px-8 py-3 rounded-md hover:bg-gray-800 transition-colors"
              data-testid="return-to-checkout-btn"
            >
              Return to Checkout
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 border border-black px-8 py-3 rounded-md hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Continue Shopping
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CheckoutCancelPage;
